// Function to count words in the text
export const countWords = (text) => {
  if (!text || typeof text !== 'string') return 0;
  return text
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;
};

// !!IMPORTANT Be careful with this function, it affect the styles of prompt templates
export const highlight = (highlightWords) => (code) => {
  // First add zero-width space after < when it's not followed by a space
  let highlightedCode = code.replace(/<(?!\s)/g, '<\u200B');

  // Then apply the HTML escaping function
  highlightedCode = highlightedCode.replace(/<[^>]+>/g, (match) =>
    escapeHTML(match)
  );

  highlightWords.forEach((highlightConfig) => {
    const { highlight, className, prefix, suffix } = highlightConfig;
    if (highlight && className) {
      highlightedCode = highlightedCode.replace(
        highlight,
        `<span class="${className}">${prefix ?? ''}$1${suffix ?? ''}</span>`
      );
    }
  });

  return highlightedCode;
};

//
export const escapeHTML = (str) => {
  const map = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    "'": '&apos;',
  };

  // eslint-disable-next-line no-useless-escape
  return str.replace(/[\<\>\&\"\']/g, (match) => map[match]);
};
